// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1WnPa","right":"Footer_right__3yDcl","buttons":"Footer_buttons__3V7GU"};